import React from 'react';

export const ownRiskMessages = {
  value: 'Own Risk',
  list: [
    {
      value: (
        <>
          All users use the site and any other websites accessed through it,
          entirely at their own risk. All users shall be responsible for their
          own communications and are responsible for the consequences of their
          activities on the Site. Glints does not represent or guarantee the
          truthfulness, accuracy or reliability of any of the communications
          posted by other users or endorse any opinions expressed by users. Any
          reliance by users on any material posted by other users shall be at
          their own risk. Glints reserves the right to expel any users and
          prevent their further access to the Site at any time for breaching the
          Terms and Conditions or violating the laws and regulations and also
          reserves the right to remove any material which is abusive, illegal,
          disruptive or inappropriate at Glints’s sole discretion without notice
          and/or consent whatsoever.
        </>
      ),
    },
  ],
};
